import { formatDateToLocaleString } from '@/shared/utils/date-utils';

// Helper functions
// Get Action Badge
export const getActionBadge = (action: string) => {
  const label = action.toUpperCase();
  switch (label) {
    case 'CREATE':
      return { label, className: `bg-green-500` };
    case 'UPDATE':
      return { label, className: `bg-blue-500` };
    case 'ASSIGN':
      return { label, className: `bg-amber-500` };
    case 'REMOVE':
      return { label, className: `bg-orange-500` };
    case 'DELETE':
      return { label, className: `bg-red-500` };
    default:
      return { label, className: `bg-gray-500` };
  }
};

// Get Action Badge
export const getMethodBadge = (method: string) => {
  const label = method.toUpperCase();
  switch (label) {
    case 'GET':
      return { label, className: `bg-green-500` };
    case 'POST':
      return { label, className: `bg-blue-500` };
    case 'PUT':
      return { label, className: `bg-amber-500` };
    case 'DELETE':
      return { label, className: `bg-red-500` };
    default:
      return { label, className: `bg-gray-500` };
  }
};

// Get Resource Type Badge
export const getResourceTypeBadge = (resourceType: string) => {
  const label = resourceType.toUpperCase();
  switch (label) {
    case 'SERVICE LINE':
      return { label, className: `bg-blue-500` };
    case 'SL - TERMINAL':
      return { label, className: `bg-green-500` };
    case 'SL - SUBSCRIPTION':
      return { label, className: `bg-purple-500` };
    case 'SL - OVERAGE':
      return { label, className: `bg-orange-500` };
    case 'SL - NAME':
      return { label, className: `bg-indigo-500` };
    default:
      return { label, className: `bg-gray-500` };
  }
};

// Format Created At
export const formatCreatedAt = (createdAt: string) => {
  return formatDateToLocaleString(createdAt);
};

// Get Status Color
export const getStatusColor = (statusCode: number | null) => {
  if (statusCode >= 200 && statusCode < 300) {
    return 'text-green-500';
  } else if (statusCode >= 400 && statusCode < 500) {
    return 'text-amber-500';
  } else if (statusCode >= 500) {
    return 'text-red-500';
  }
  return 'text-gray-500';
};


// Audit Log Interface
export interface AuditLog {
  id: number;
  userId: string;
  emailId: string;
  role: string;
  organizationId: string;
  regionCode: string;
  action: string;
  resourceUri: string;
  resourceType: string;
  serviceLineNumber: string | null;
  serviceLineName: string | null;
  userAgent: string;
  kitNumbers: string | null;
  overageData: string | null;
  overageEndDate: string | null;
  baseSubscriptionId: string;
  baseSubscriptionData: string | null;
  metadata: {
    request: {
      uri: string;
      method: string;
      headers: Record<string, any>;
      userAgent: string;
      remoteAddr: string;
      contentType: string;
      queryString: string;
      pathVariables: Record<string, any>;
      body: Record<string, any>;
    } | null;
    response: {
      body: Record<string, any>; // Can be Map, object, or string with various response structures
      statusCode: number | null;
    } | null;
    timestamp: number | null;
  } | null;
  createdAt: string;
}